import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";

const SubProduct = () => {
  const [subProductData, setSubProductData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productDrp, setProductDrpData] = useState([]);
  const [formData, setFormData] = useState({
    product_id: null,
  });
  const getSubProduct = () => {
    setLoading(true);
    axios
      .post(API_URL.SUB_PRODUCT_LIST, {
        product_id: formData.product_id,
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setSubProductData(res.data.data);
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,
            
          });
        }
      );
  };
  
  const getProductDrpData = () => {
    axios.post(API_URL.PRODUCT_HAS_SUB_PRODUCT, {}).then((res) => {
      setProductDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.category?.name + ' - ' + caw.name,
          value: caw.id,
        };
      });
      setProductDrpData(cd);
    });
  };

  const deletProduct = (row) => {
    Swal.fire({
      title: "Are you sure?", 
      text: "You want to delete this SubProduct ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SUB_PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            setLoading(false);
            if (res.data.status === 1) {
              let newData = subProductData.filter((r) => r.id != row.id);
              setSubProductData(newData);
              toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            } else {
              toast.error(res.data.data || "Something went wrong..", { autoClose: 3000 });
            }
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getProductDrpData();
  }, []);

  useEffect(() => {
    if (formData.product_id) {
      getSubProduct();
    }
  }, [formData.product_id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Sub Product
            <small className="me-2">({subProductData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <Select
                placeholder="Select Product"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={productDrp}
                value={productDrp.find((r) => r.value == formData.product_id)}
                styles={styles}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    product_id: e.value,
                  });
                }}
              />
            </div>
            <Link to={"/product/sub-product/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              SubProduct
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th width="100">Image</th>
                        <th>Name</th>
                        <th>Size</th>
                        <th>Weight</th>
                        <th className="form-group" style={{ width: "300px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {subProductData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td className="table-avatar">
                              <div style={{backgroundImage: "url(" + row.image + ")"}}></div>
                            </td>
                            <td>{row.product_name} - {row.name}</td>
                            <td>{row.size_name}</td>
                            <td>{row.weight}</td>
                            <td
                              className="d-flex gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/product/sub-product/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deletProduct(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      { !formData.product_id && 
                        <tr>
                          <td className="text-center" colSpan={6}>
                            <h2>Please select main product</h2>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubProduct;
